import targetsService from '@/api/targetsService'
import { TARGET_OPTIONS } from '@/utils/adminOptions'

/**
 *  TargetDetail script file
**/

export default {
  name: 'TargetDetail',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      target: {}
    }
  },
  computed: {
    isThirdParty () {
      return this.target.type === TARGET_OPTIONS[1].value
    }
  },
  async mounted () {
    this.$emit('selectTab', { id: 'targets' })
    this.target = await targetsService.getTarget({ id: this.$route.params.targetid })
  },
  methods: {
    closeModal () {
      this.$router.push('/administration')
    },
    async removeTarget () {
      await targetsService.deleteTarget(this.target)
      this.$router.push({ path: `/administration` })
      this.$emit('delete', { type: 'targets' })
    }
  }
}
